import { FC, memo } from 'react'
import { Box, useToken, useColorModeValue } from '@chakra-ui/react'

type Props = {
  size?: number
}

const DigitalArchiveModuleBrand: FC<Props> = ({ size = 12 }) => {
  const [primary200, primary300, primary400, primary500, primary600, primary700, primary900, white] = useToken('colors', [
    'primary.200',
    'primary.300',
    'primary.400',
    'primary.500',
    'primary.600',
    'primary.700',
    'primary.900',
    'white',
  ])

  const strokeColor900 = useColorModeValue(primary900, primary900)
  const strokenWidth40 = '40px'
  const strokenWidth30 = '30px'
  const strokenWidth20 = '20px'
  const fillColor200 = useColorModeValue(primary200, primary300)
  const fillColor400 = useColorModeValue(primary400, primary500)
  const fillColor600 = useColorModeValue(primary600, primary700)
  const fillBG = useColorModeValue(white, white)

  return (
    <Box w={size} h={size} pos="relative">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800">
        <g id="Acervo_Digital" data-name="Acervo Digital">
          <g id="background">
            <g id="group200">
              <path
                fill={fillColor200}
                opacity="0.25"
                d="M396,72.8S489.46,54.46,566.56,135s76.13,52.92,112,75.26,86.08,105.36,53.07,167.28S589.79,462.6,542.37,504.39s-48.13,123.9-107.45,162.24-144.47,49.85-201.61,14.2-107-113.69-96.85-160.53,45.25-95.92,47.94-124.14-26.4-92.54-3.56-154.07S243.11,90.63,396,72.8Z"
              />
            </g>
            <g id="group400">
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M731.49,442.19S690.36,496,627.1,460.34s-87.5,2-124.87-47.81-30.54-109.95-3.55-136.15,40.93-12,62.71-64.55c26.47-63.9,91.36-11.53,98.47,28.23,6.52,36.52,22.8,64.67,50,80.62C732.32,333.78,774.72,398.5,731.49,442.19Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M629.27,619.53S618.58,686.41,546,685s-76.11,43.21-132.61,17.13-79-82.33-67.69-118.19S376,554,370.28,497.38c-7-68.8,75-53.47,100.07-21.83,23.06,29.05,50.74,46.12,82.3,47.23C578.59,523.7,646.62,560.57,629.27,619.53Z"
              />
              <path
                fill={fillColor400}
                opacity="0.2"
                d="M309.32,116.8s63.82,22.69,49.23,93.83,28.64,82.7-7.29,133.51-95.33,62.73-128.53,45.06-23.92-35.31-80.65-39.95c-68.93-5.64-38.94-83.44-3.26-102.38,32.76-17.38,54.58-41.5,61.42-72.33C205.86,149.2,254.49,89,309.32,116.8Z"
              />
            </g>
            <g id="group600">
              <path
                fill={fillColor600}
                d="M727.88,259.56c-14.22,13.15-32.52,8.59-41.38-5.87-8.18-12.78-12.55-41.41.38-50.82,13.15-9.56,36.4,6.63,44.15,20.71a36.59,36.59,0,0,1,2.94,27A24.83,24.83,0,0,1,727.88,259.56Z"
              />
              <path
                fill={fillColor600}
                d="M147.94,703.71c2.05-19.2,22.24-27,40-28.82,2-.2,3.9-.93,5.76-1.11a8.15,8.15,0,0,1,8.73,4.69,36.2,36.2,0,0,1,1.67,5.88c5.56,22.16.87,52.9-25.59,53.65-14.55,1-27.21-11.53-30.31-24.93A46.19,46.19,0,0,1,147.94,703.71Z"
              />
              <path
                fill={fillColor600}
                d="M175.35,226.5c-3.82.46-7.75-1.41-10.62-4l-.09-.08c-6.3-6.64-7.35-16.77-4.31-25.25a55.25,55.25,0,0,1,35-32.95c4.58-1.46,10.48-1.93,15.28,3.25a13.77,13.77,0,0,1,2.67,3.79C219.11,183.3,193.86,224.23,175.35,226.5Z"
              />
              <path
                fill={fillColor600}
                d="M96.75,531.35s-43-77.93-7.64-165.37S214.42,310.41,267.9,281.5s15-140.82,117-166.69,153.31-3.94,189.5,40.94c24.56,30.45,1.84,91.91,17.68,157.18,15.89,65.48,86.12,81.54,113.3,134.59s-17,108.39-36.67,128.37-32.6,29.89-85.47,57.31c-53,27.5-143.5,32.83-179.78,30.45-59.93-3.93-117-16.14-166-33.4C167.7,605.69,119.56,582.11,96.75,531.35Z"
              />
            </g>
          </g>
          <g id="icon">
            <path
              fill={fillBG}
              strokeWidth={strokenWidth40}
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M195.54,448.4V582.83A46.15,46.15,0,0,0,241.68,629h323a46.15,46.15,0,0,0,46.15-46.15V448.4a184.69,184.69,0,0,0-7.78-53L558.43,246.54a46.15,46.15,0,0,0-44.2-32.89H292.17A46.14,46.14,0,0,0,248,246.54L203.32,395.36A184.69,184.69,0,0,0,195.54,448.4Z"
            />
            <path
              fill="none"
              strokeWidth={strokenWidth30}
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M472.42,490.53v23.08a23.07,23.07,0,0,1-23.07,23.07h-92.3A23.07,23.07,0,0,1,334,513.61V490.53"
            />
            <line
              fill="none"
              stroke={strokeColor900}
              strokeWidth={strokenWidth40}
              strokeLinecap="round"
              strokeLinejoin="round"
              x1="608.84"
              y1="421.31"
              x2="197.55"
              y2="421.31"
            />
            <line
              fill="none"
              strokeWidth={strokenWidth20}
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              x1="483.96"
              y1="282.87"
              x2="322.44"
              y2="282.87"
            />
            <line
              fill="none"
              strokeWidth={strokenWidth20}
              stroke={strokeColor900}
              strokeLinecap="round"
              strokeLinejoin="round"
              x1="507.03"
              y1="352.09"
              x2="299.37"
              y2="352.09"
            />
          </g>
        </g>
      </svg>
    </Box>
  )
}

export default memo(DigitalArchiveModuleBrand)
